import { CountryCode } from 'libphonenumber-js';

// TODO: this does not work but it's not a big deal, it just defaults to international
function isCountryCode(countryCode: string): countryCode is CountryCode {
  return (countryCode as CountryCode) !== undefined;
}

export default function getCountryCode(countryCode: string): CountryCode {
  if (isCountryCode(countryCode)) {
    return countryCode;
  }
  return 'BE';
}
